// extracted by mini-css-extract-plugin
export default {"carCard":"CarList_carCard__8VjLK","carCardHolder":"CarList_carCardHolder__jVdXY"};